import React, {useState} from 'react';
import useMerchantPortalAxios from "../utils/axios";

function useReportsApi() {
    const MerchantPortalAxios = useMerchantPortalAxios();
    const [reports, setReports] = useState();
    const [reportsLoading, setReportsLoading] = useState(false);
    const [totalNbOfPage, setTotalNbOfPage] = useState(1);
    const [totalCount, setTotalCount] = useState(1);

    const [history, setHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);

    const [detailsReport, setDetailsReport] = useState([]);

    const getReports = async (page, object) => {
        const {dateFrom, dateTo, frequency, branches, transactionTypes, currency, tills} = object;

        setReportsLoading(true);
        const res = await MerchantPortalAxios.post('/v1/Report', {
            SessionID: sessionStorage.getItem("SessionID"),
            page: page,
            pageSize: 10,
            DateFrom: dateFrom,
            DateTo: dateTo,
            Frequency: frequency,
            Branches: branches,
            Tills: tills,
            TransactionTypes: transactionTypes,
            Currency: currency,
            
        }).then((res) => {
            setReports(res.data.Payload?.Templates);
            if (res.data.Payload?.Templates?.length === 0) {
                setTotalNbOfPage(0);
                setTotalCount(0);
            } else {
                setTotalNbOfPage(res.data.Payload?.PageCount);
                setTotalCount(res.data.Payload?.TotalCount)
            }

            setReportsLoading(false);
        });
    }

    const getHistory = async (page, dateFrom, dateTo,currency) => {
        setHistoryLoading(true);
        const res = await MerchantPortalAxios.post('/v1/Report/History', {
            SessionID: sessionStorage.getItem("SessionID"),
            page: page,
            pageSize: 10,
            DateFrom: dateFrom,
            DateTo: dateTo,
            Currency:currency
          
        }).then((res) => {
            setHistory(res.data.Payload?.Templates);
            
            if (res.data.Payload?.Templates?.length === 0) {
                setTotalNbOfPage(0);
                setTotalCount(0);

            } else {
                setTotalNbOfPage(res.data.Payload?.PageCount);
                setTotalCount(res.data.Payload?.TotalCount);
            }
            setHistoryLoading(false);
        });
    }


    const newReport = async(payload) => {
        const res = await MerchantPortalAxios.post('/v1/Report/new', payload);
        return res.data.Payload;
    }

    const resendReport = async(payload) => {
        const res = await MerchantPortalAxios.post('/v1/Report/resend', payload);
        return res.data.Payload;
    }

    const deleteReport = async(payload) => {
        const res = await MerchantPortalAxios.post('/v1/Report/delete', payload);
        return res.data.Payload;
    }

    const updateReport = async(payload) => {
        const res = await MerchantPortalAxios.post('/v1/Report/update', payload);
        return res.data.Payload;
    }

    const getReportDetails = async(reportId) => {
        const res = await MerchantPortalAxios.post(
            `/v1/Report/details`, {
                SessionID: sessionStorage.getItem("SessionID"),
                ReportID: reportId
            }
        );
        return res?.data;
    }

    return {
        getReports,
        reports,
        reportsLoading,
        totalNbOfPage,
        totalCount,
        getHistory,
        history,
        historyLoading,
        newReport,
        deleteReport,
        resendReport,
        updateReport,
        getReportDetails,
        detailsReport
    };
}

export default useReportsApi;
